import App from '@/models/App'
import Profile from '@/models/Profile'
import OrganizationDetail from '@/models/OrganizationDetail'

export default class Organization extends App {
    static get entity() {
        return 'organizations'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static one() {
        return this.query().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            code: this.attr(''),
            country: this.attr(''),
            industry: this.attr(''),
            nameJa: this.attr(''),
            nameEn: this.attr(''),
            postal: this.attr(''),
            address: this.attr(''),
            url: this.attr(''),
            tel: this.attr(''),
            email: this.attr(''),
            logoImage: this.attr(''),
            profile: this.hasOne(Profile, 'organizationId'),
            organizationDetail: this.hasOne(
                OrganizationDetail,
                'organizationId',
                'id'
            ),
        }
    }
    static apiConfig = {
        actions: {
            find(organizationId) {
                return this.get(`/organizations/${organizationId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            update(organizationId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `/organizations/${organizationId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
